/**
 * @fileoverview Unlisted route for the ecosystem grants deck presentation
 * @module routes/grants-deck
 */

import type { ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import OnicornDeck from '@/features/grants-deck/OnicornDeck';

/**
 * Grants deck page component.
 *
 * This is an unlisted route — not linked from any navigation.
 * Accessible only by sharing the URL directly.
 *
 * @component
 */
function GrantsDeckPage(): ReactElement {
  return <OnicornDeck />;
}

export const Route = createFileRoute('/grants-deck')({
  component: GrantsDeckPage,
});
